import { Capacitor } from "@capacitor/core";
import { Camera } from "@capacitor/camera";

// Photo capture throughout the app uses a plain <input type="file"
// capture="environment"> rather than the Camera plugin's own picker (see
// PhotoPickerButtons.tsx) — cheaper for the common "pick from gallery too"
// case. But on Android that HTML capture attribute silently fails to open
// the camera on some OEM WebView builds if the app has never actually been
// granted the CAMERA permission yet, with no prompt and no error — exactly
// the "camera permission not being asked" behavior testers reported. Priming
// it once via the Camera plugin (which does trigger a real system dialog)
// fixes that without changing how photos are actually picked.
const CAMERA_PRIME_KEY = "toletbook_camera_permission_primed";

export async function primeCameraPermission(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  if (localStorage.getItem(CAMERA_PRIME_KEY)) return;
  localStorage.setItem(CAMERA_PRIME_KEY, "1");
  try {
    await Camera.requestPermissions({ permissions: ["camera"] });
  } catch {
    // Denied or unavailable — the in-context capture attempt will just
    // fail the same way it always has; nothing further to do here.
  }
}
